import styled from 'styled-components';

export const ExpandedMobileItemBody = styled.div`
  padding-left: 12px;
`;
